import * as React from "react"
import { useAppDispatch, useAppSelector } from "@/hooks/useReduxHooks";
import { getSubDomain } from "@/lib/location";

export function useIsVendorWebsite() {
    const {getWebsiteBySubdomainResponse} = useAppSelector(state => state.auth);
    const sub=!!getSubDomain()
  const [isVendorWebsite, setIsVendorWebsite] = React.useState<boolean | undefined>(sub)
  React.useEffect(() => {
        if(getWebsiteBySubdomainResponse?.payload?.isWebsiteActive){
            setIsVendorWebsite(true)
        }
  }, [getWebsiteBySubdomainResponse?.payload])

  return !!isVendorWebsite
}
